export default "<span [countUp]=\"count\" >0</span>"